import { createPortal } from 'react-dom';

import { Wrapper } from '@american-autonomy/ag-ui';

import ErrorNotification from 'components/notifications/ErrorNotification';
import { useToastContext } from 'components/providers/ToastProvider';

import { ERROR, TEST_ID } from './constants';
import type { FunctionComponent, NotificationType, NotificationsMap, Props } from './types';

import styles from './styles.module.scss';

const notificationsMap: NotificationsMap = {
    error: ErrorNotification
};

const Toast: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { clearToast, handleRetry, toast } = useToastContext();
    const type = toast?.type;
    const text = toast?.text;
    const hasRetry = type === ERROR;

    const ToastComponent = type ? notificationsMap[type as NotificationType] : null;

    if (!type) {
        return null;
    }

    return createPortal(
        <Wrapper className={styles.toast} data-testid={testId}>
            <ToastComponent
                onClick={hasRetry ? handleRetry : undefined}
                onClose={clearToast}
                text={text}
            />
        </Wrapper>,

        document.body
    );
};

export default Toast;
